export const APP_VERSION = "1.0.47";
export const APP_VERSION_CODE = 48;

export const SERVER_BASE_URL = "https://finaarte.duckdns.org";
export const APK_DOWNLOAD_URL = `${SERVER_BASE_URL}/downloads/fina-mabe-erp.apk`;
export const VERSION_CHECK_URL = `${SERVER_BASE_URL}/version.json`;
